<template>
  <div class="list-page country-select">
    <div class="detail-banner">
      <div class="container">
        <h1>国家资讯</h1>
        <div class="sub">按大洲选择国家，查看该国官方资讯与出海服务</div>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <!-- 大洲切换 tab -->
        <div class="continent-tabs">
          <span
            v-for="tab in tabList"
            :key="tab"
            class="continent-tab"
            :class="{ active: tab === activeContinent }"
            @click="activeContinent = tab"
          >{{ tab }}</span>
        </div>

        <div class="country-search">
          <span class="search-ico">🔍</span>
          <input
            v-model="keyword"
            class="country-search-input"
            type="text"
            placeholder="搜索你想查看的国家"
          />
        </div>

        <div v-if="loading" class="empty-block">加载中…</div>
        <div v-else-if="!displayCountries.length" class="empty-block">未找到匹配的国家</div>

        <div v-else class="country-grid">
          <div
            v-for="c in displayCountries"
            :key="c.id"
            class="country-item"
            @click="$router.push('/country/' + c.id)"
          >
            <img
              v-if="c.icon"
              :src="c.icon"
              :alt="c.name"
              class="country-flag"
              @error="onImgError"
            />
            <span v-else class="country-flag-placeholder">{{ c.name.slice(0, 1) }}</span>
            <span class="country-name">{{ c.name }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchCountryList } from '../api/home'

export default {
  name: 'CountryList',
  data () {
    return {
      groups: [],
      keyword: '',
      activeContinent: '全部',
      loading: true
    }
  },
  computed: {
    tabList () {
      return ['全部', ...this.groups.map(g => g.continent)]
    },
    displayCountries () {
      const kw = this.keyword.trim().toLowerCase()
      let list = []
      if (this.activeContinent === '全部') {
        this.groups.forEach(g => { list = list.concat(g.countries) })
      } else {
        const g = this.groups.find(x => x.continent === this.activeContinent)
        list = g ? g.countries : []
      }
      if (kw) {
        list = list.filter(c => c.name.toLowerCase().includes(kw))
      }
      return list
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.groups = await fetchCountryList()
      } catch (e) {
        this.groups = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.continent-tabs {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  margin-bottom: 18px;
  scrollbar-width: none;
}
.continent-tabs::-webkit-scrollbar {
  display: none;
}
.continent-tab {
  flex-shrink: 0;
  padding: 9px 20px;
  border-radius: 20px;
  background: var(--blue-soft-2, #f4f7fe);
  border: 1px solid var(--border);
  color: var(--text-sub);
  font-size: 14.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.continent-tab:hover {
  color: var(--primary);
}
.continent-tab.active {
  background: var(--primary);
  color: #fff;
  border-color: var(--primary);
}

.country-search {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--blue-soft, #eaf0fe);
  border-radius: 16px;
  padding: 16px 20px;
  margin-bottom: 28px;
}
.search-ico {
  font-size: 18px;
  opacity: 0.6;
}
.country-search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 15px;
  color: var(--text-main);
}
.country-search-input::placeholder {
  color: #9aa6c0;
}

.country-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
@media (max-width: 900px) {
  .country-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 600px) {
  .country-grid { grid-template-columns: repeat(2, 1fr); }
}

.country-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--blue-soft-2, #f4f7fe);
  border: 1.5px solid transparent;
  border-radius: 14px;
  padding: 14px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.country-item:hover {
  background: #fff;
  border-color: var(--primary);
  box-shadow: 0 6px 18px rgba(36, 68, 203, 0.12);
  transform: translateY(-2px);
}
.country-flag {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}
.country-flag-placeholder {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--primary);
  color: #fff;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.country-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-main);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-block {
  text-align: center;
  color: var(--text-sub, #9aa6c0);
  padding: 40px 0;
}
</style>
